import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BACKGROUND_REQUEST, SILENT_REQUEST } from "@interceptors/silent-request.token";
import { environment } from "../../../environments/environment";

/**
 * `silent`: no full-screen loader. `background`: a poll - silent, and an expired session
 * stops polling (`silentSessionExpired`) instead of redirecting to /login.
 */
export interface RequestOptions {
  silent?: boolean;
  background?: boolean;
}

const context = (options?: RequestOptions) =>
  new HttpContext()
    .set(SILENT_REQUEST, !!options?.silent || !!options?.background)
    .set(BACKGROUND_REQUEST, !!options?.background);

/** `X-Background: 1` tells the backend not to renew the session for a poll. */
const headers = (options?: RequestOptions) =>
  // eslint-disable-next-line @typescript-eslint/naming-convention
  options?.background ? new HttpHeaders({ "X-Background": "1" }) : undefined;

@Injectable({
  providedIn: "root",
})
export class RequestService {
  constructor(private http: HttpClient) {}

  get<T>(baseurl: string, options?: RequestOptions) {
    return this.http.get<T>(environment.backendURL + baseurl, {
      context: context(options),
      headers: headers(options),
    });
  }
  post<T>(baseurl: string, data?: any, options?: RequestOptions) {
    return this.http.post<T>(environment.backendURL + baseurl, data, {
      context: context(options),
      headers: headers(options),
    });
  }
  patch<T>(baseurl: string, data?: any) {
    return this.http.patch<T>(environment.backendURL + baseurl, data);
  }

  put<T>(baseurl: string, data?: any) {
    return this.http.put<T>(environment.backendURL + baseurl, data);
  }
  /** A file (a PDF, say) rather than JSON. */
  getBlob(baseurl: string) {
    return this.http.get(environment.backendURL + baseurl, { responseType: "blob" });
  }
  delete<T>(baseurl: string) {
    return this.http.delete<T>(environment.backendURL + baseurl);
  }
}
